import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_REQUESTS_WITHOUT_BODY() {
  _init_properties_HttpMethod_kt__cbus5z();
  return REQUESTS_WITHOUT_BODY;
}
var REQUESTS_WITHOUT_BODY;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o50_1 = new (HttpMethod())('GET');
        this.p50_1 = new (HttpMethod())('POST');
        this.q50_1 = new (HttpMethod())('PUT');
        this.r50_1 = new (HttpMethod())('PATCH');
        this.s50_1 = new (HttpMethod())('DELETE');
        this.t50_1 = new (HttpMethod())('HEAD');
        this.u50_1 = new (HttpMethod())('OPTIONS');
        this.v50_1 = new (HttpMethod())('TRACE');
        this.w50_1 = new (HttpMethod())('QUERY');
        this.x50_1 = listOf([this.o50_1, this.p50_1, this.q50_1, this.r50_1, this.s50_1, this.t50_1, this.u50_1]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ {
      constructor(value) {
        Companion_getInstance();
        this.y50_1 = value;
      }
      toString() {
        return this.y50_1;
      }
      hashCode() {
        return getStringHashCode(this.y50_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpMethod()))
          return false;
        if (!(this.y50_1 === other.y50_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
function get_supportsRequestBody(_this__u8e3s4) {
  _init_properties_HttpMethod_kt__cbus5z();
  return !get_REQUESTS_WITHOUT_BODY().y2(_this__u8e3s4);
}
var properties_initialized_HttpMethod_kt_ogor3f;
function _init_properties_HttpMethod_kt__cbus5z() {
  if (!properties_initialized_HttpMethod_kt_ogor3f) {
    properties_initialized_HttpMethod_kt_ogor3f = true;
    REQUESTS_WITHOUT_BODY = setOf([Companion_getInstance().o50_1, Companion_getInstance().t50_1, Companion_getInstance().u50_1, Companion_getInstance().v50_1]);
  }
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance12092dx8psw4e,
  get_supportsRequestBody as get_supportsRequestBodyjdtitrt33hir,
};
//endregion

//# sourceMappingURL=HttpMethod.mjs.map
